export default __webpack_public_path__ + "static/media/vector4.9971f954.gif";